import React from "react";
import { useMutation } from "@apollo/client";
import { gql } from "@apollo/client";
import { Form } from "react-final-form";
import { Dialog } from "@syos-music/common";

import { Alert, Button, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

const MUTATION = gql`
  mutation ($id: ID!) {
    DeleteTemplate(id: $id) {
      template {
        id
        deleted
      }
    }
  }
`;

export default function DeleteTemplateDialog({ onTemplateDeleted, children }) {
  const [template, setTemplate] = React.useState(null);
  const close = () => setTemplate(null);

  const [deleteTemplate] = useMutation(MUTATION);

  return (
    <>
      {children({ open: setTemplate, close })}

      <Dialog open={!!template} onClose={close}>
        <Form
          onSubmit={() =>
            deleteTemplate({ variables: { id: template.id } })
              .then(() => {
                close();
                onTemplateDeleted();
              })
              .catch(() => true)
          }
          keepDirtyOnReinitialize
        >
          {({ handleSubmit, submitting, invalid }) => (
            <form onSubmit={handleSubmit} noValidate autoComplete="off">
              <Dialog.Title color="primary">Supprimer un template</Dialog.Title>

              <Dialog.Content>
                <Alert severity="warning">
                  <Typography color="inherit">
                    Voulez-vous vraiment supprimer le template 
                    <code>{template?.name}</code> ?
                  </Typography>
                </Alert>
              </Dialog.Content>

              <Dialog.Actions>
                <Button variant="text" onClick={close}>
                  Annuler
                </Button>

                <LoadingButton type="submit" loading={submitting}>
                  Supprimer
                </LoadingButton>
              </Dialog.Actions>
            </form>
          )}
        </Form>
      </Dialog>
    </>
  );
}

DeleteTemplateDialog.fragments = {
  template: gql`
    fragment DeleteTemplateDialog_template on Template {
      id
      name
    }
  `,
};
